import * as ex from 'excalibur';
import { WORLD_WIDTH, WORLD_HEIGHT } from './config/constants';
import { Game } from './game';
import { loader, Resources } from './resources';

// Create the Excalibur game engine with explicit configuration
const engine = new ex.Engine({
  width: 320,
  height: 240,
  pixelRatio: 2,
  backgroundColor: ex.Color.fromHex('#000000'),
  displayMode: ex.DisplayMode.FitContainer, // Use FitContainer instead of FitScreen
  suppressPlayButton: true, // Start immediately
  pointerScope: ex.Input.PointerScope.Document,
  antialiasing: false, // Disable antialiasing for better performance with pixel art
  fixedUpdateFps: 60, // Set fixed update to 60fps
  canvasElementId: 'game', // Target a specific canvas element (will be created if it doesn't exist)
});

// Add the main game scene
const game = new Game();
engine.add('game', game);

// Print controls to console
console.log('=== Natural Ecosystem Simulation ===');
console.log('Controls:');
console.log('- WASD / Arrow Keys: Pan camera');
console.log('- Click: Inspect entity');
console.log('- Ctrl+Click: Add random animal');
console.log('- F2: Center camera on world');
console.log('- F3: Toggle debug grid');

// Log that we're starting to load resources
console.log('Loading resources...');

// Start the game after loading
engine.start(loader).then(() => {
  // Log resource loading complete
  console.log('Resources loaded successfully!');

  // Log if the bird resource loaded properly
  console.log('Bird resource loaded:', Resources.Bird.isLoaded());

  // Start with the game scene
  engine.goToScene('game');
  console.log('Game started successfully!');

  // Force an update to ensure everything is initialized properly
  game.update(engine, 16.67); // 16.67ms is approx. one frame at 60fps
}).catch((error) => {
  // Log any errors during loading
  console.error('Failed to load resources:', error);
});

// Add a global error handler to log any Excalibur errors
window.addEventListener('error', (e) => {
  console.error('Game Error:', e.error);
});
